import React from 'react';
import { StyledContainer } from './Container.styled';
import { StyledInput } from './Input.styled';
import { StyledTextContainer } from './TextContainer.styled';

interface IEntitySelectorFilterProps {
	children?: React.ReactNode;
	onChange?: (newValue: string) => void;
}

const EntitySelectorFilter: React.FC<IEntitySelectorFilterProps> = ({
	children,
	onChange,
}) => {
	return (
		<StyledContainer>
			<StyledTextContainer>{children}</StyledTextContainer>
			<StyledInput onChange={(e) => onChange?.(e.currentTarget.value)} />
		</StyledContainer>
	);
};

export { EntitySelectorFilter };
